import { render, staticRenderFns } from "./BasicInformation.vue?vue&type=template&id=7ec96fc0&scoped=true&"
import script from "./BasicInformation.vue?vue&type=script&lang=js&"
export * from "./BasicInformation.vue?vue&type=script&lang=js&"
import style0 from "./BasicInformationUnScoped.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./BasicInformation.css?vue&type=style&index=1&id=7ec96fc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec96fc0",
  null
  
)

export default component.exports